import React, { useState, useEffect } from "react";
import MaterialTable from "@material-table/core";
import * as APIModels from "../../../models";
import { TylerAdminService } from "../../../services/ClientService";
import { Globals } from "../../../helpers/globals";
import UserUpdateModal from "./modals/UserUpdateModal";

export default function Users() {
    const never = "never" as const;
    const onInsert = "onAdd" as const;

    // Globals ------------------------------------------------------------
    const currentUser = Globals.currentUserValue;
    // --------------------------------------------------------------------

    // States -------------------------------------------------------------
    const [data, setData] = useState([] as APIModels.TylerUser[]);
    const [modal, setModal] = useState(false);
    const [updating, setUpdating] = useState({} as APIModels.TylerUser);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    // --------------------------------------------------------------------

    // We have roles make sure to fix premisions
    useEffect(() => {
        console.log("Tyler Users Page");
        TylerAdminService.getUsers()
            .then((res) => {
                if (res && res.successful) {
                    setData((_prev) => {
                        return [...res.data!];
                    });
                    setSuccess("Users Loaded Successfully");
                    setError("");
                } else {
                    console.log(res.errorMessage!);
                    setError(res.errorMessage!);
                    setSuccess("");
                }
            })
            .then(() => console.log(data));
    }, []);

    // [ ] TODO:
    const deleteTylerUser = async (id: string) => {
        const res = await TylerAdminService.deleteUser({ id });
        if (res && res.successful && res.data) {
            const newData = data.filter((user) => user.id !== id);
            setData(newData);
            setSuccess("User Deleted Successfully");
            setError("");
        } else {
            console.log(res.errorMessage!);
            setError(res.errorMessage!);
            setSuccess("");
        }
    };

    return (
        <div>
            {modal && (
                <UserUpdateModal
                    close={setModal}
                    addUserModal={modal}
                    user={updating}
                    users={data}
                    setUsers={setData}
                />
            )}
            <a className="btn btn-primary p-2 mb-2 w-25" href="/tyler/register">
                <span>Create A New User</span>
            </a>
            <div className="row">
                <div className="col-12">
                    <div style={{ maxWidth: "100%" }}>
                        <MaterialTable
                            columns={[
                                { title: "First Name", field: "firstName" },
                                { title: "Last Name", field: "lastName" },
                                { title: "Email", field: "email" },
                            ]}
                            data={data}
                            title="Users"
                            options={{
                                actionsColumnIndex: -1,
                                pageSizeOptions: [5, 10, 20, 50, 75, 100],
                            }}
                            actions={[
                                {
                                    icon: "update",
                                    tooltip: "Update",
                                    onClick: (_, rowData) => {
                                        setUpdating(
                                            rowData as APIModels.TylerUser
                                        );
                                        setModal(true);
                                    },
                                },
                                {
                                    icon: "delete",
                                    tooltip: "Delete",
                                    onClick: (_, rowData) => {
                                        const data =
                                            rowData as APIModels.TylerUser;
                                        if (data.id) {
                                            deleteTylerUser(data.id);
                                        }
                                    },
                                },
                            ]}
                        />
                    </div>
                </div>
            </div>
            {error !== "" && (
                <div className="col-12">
                    <div className="alert alert-danger">{error}</div>
                </div>
            )}
            {success !== "" && (
                <div className="col-12">
                    <div className="alert alert-success">{success}</div>
                </div>
            )}
        </div>
    );
}
